import axios from 'axios';
import {api} from '../../constants/api';

export const deleteFile = ({shumaId, fileID}) => dispatch => {
  const data = {
    shumaID: parseInt(shumaId, 10),
    fileID: parseInt(fileID, 10),
  };

  return axios.post(api.DELETE_FILE, data)
    .then(response => {
      const {errorCode} = response.data;

      return errorCode;
    })
    .catch((err) => {
      console.error('deleteFile returns error:');
      console.error(err);
    });
};

export const deleteOrderFile = ({orderID, fileID}) => dispatch => {
  const data = {
    orderID: parseInt(orderID, 10),
    fileID: parseInt(fileID, 10),
  };

  return axios.post(api.DELETE_ORDER_FILE, data)
    .then(response => {
      const {errorCode} = response.data;

      return errorCode;
    })
    .catch((err) => {
      console.error('deleteFile returns error:');
      console.error(err);
    });
};
